import { Box, Typography } from "@mui/material";
import React from "react";
import CircleIcon from "@mui/icons-material/Circle";

export default function Bullet({ children }) {
  return (
    <Box sx={{ display: "flex", pl: 1, pt: 1 }}>
      <CircleIcon sx={{ fontSize: 18, pt: 1 }} />
      <Typography sx={{ pl: 1, lineHeight: 1.8 }}>{children}</Typography>
    </Box>
  );
}
